// Single source of truth for supported languages
export const SUPPORTED_LANGUAGES = ['en', 'it', 'es', 'de', 'tr'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

// Pre-built regex segment for path matching: "en|it|es|de|hr"
export const LANGUAGE_REGEX_GROUP = SUPPORTED_LANGUAGES.join('|');
